import React from 'react';

const SVG = ({ style = {}, solid, color = 'white', width = '100%' }) => {
  return (
    <svg style={style} width={width} height={width} viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <g id="id-youtube">
          <path
            fill="red"
            d="M 118.9 13.3 c -1.4 -5.2 -5.5 -9.3 -10.7 -10.7 C 98.7 0 60.7 0 60.7 0 s -38 0 -47.5 2.5 C 8.1 3.9 3.9 8.1 2.5 13.3 C 0 22.8 0 42.5 0 42.5 s 0 19.8 2.5 29.2 c 1.4 5.2 5.5 9.3 10.7 10.7 C 22.8 85 60.7 85 60.7 85 s 38 0 47.5 -2.5 c 5.2 -1.4 9.3 -5.5 10.7 -10.7 c 2.5 -9.5 2.5 -29.2 2.5 -29.2 S 121.5 22.8 118.9 13.3 Z"
          />
          <polygon fill="white" points="48.6,60.7 80.2,42.5 48.6,24.3  " />
        </g>
      </defs>
      <g>
        {solid ? (
          <>
            <circle cx="50" cy="50" r="50" fill={color} />
            <use xlinkHref="#id-youtube" href="#id-youtube" transform="scale(0.5) translate(40,60)" />
          </>
        ) : (
          <>
            <circle fill="none" stroke={color} strokeWidth="8" cx="50" cy="50" r="46" />
            <use xlinkHref="#id-youtube" href="#id-youtube" transform="scale(0.45) translate(50,70)" />
          </>
        )}
      </g>
    </svg>
  );
};

export default SVG;
